import React from 'react';

const MultipleMemberGroup = () => {

    return (
        <div style={{ display: "flex", alignItems: "center", gap: "1rem", margin: "1rem" }}>
            <p>Multiple Groups</p>
        </div>
    );
};

export default MultipleMemberGroup;
